import { render, staticRenderFns } from "./loaderror.vue?vue&type=template&id=10d1a549&scoped=true"
import script from "./loaderror.vue?vue&type=script&lang=js"
export * from "./loaderror.vue?vue&type=script&lang=js"
import style0 from "./loaderror.vue?vue&type=style&index=0&id=10d1a549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1a549",
  null
  
)

export default component.exports